var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 26.5626C19.875 31.2225 16.0974 35 11.4375 35C6.77759 35 3 31.2225 3 26.5626C3 21.9027 6.77759 18.1251 11.4375 18.1251C16.0974 18.1251 19.875 21.9027 19.875 26.5626Z",
    fill: "#AED1EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4374 18L37 26.5626L28.4374 35.1252L19.8748 26.5626L28.4374 18Z",
    fill: "#EA5032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcoClose);
export default __webpack_public_path__ + "static/media/Logo_ico_close.0bdd79bd18b917bb2f5ffd9ce8094ba0.svg";
export { ForwardRef as ReactComponent };